export class SelectionToolbar {
  readonly toolbarUnchecked: Element | null
  readonly toolbarChecked: Element | null
  readonly selectedCountDisplay: Element | null

  constructor(
    readonly table: HTMLTableElement,
    readonly toolbar: HTMLDivElement,
    skipClear: boolean = false,
  ) {
    this.toolbarUnchecked = this.toolbar.querySelector('[data-toolbar="unselected"]')
    this.toolbarChecked = this.toolbar.querySelector('[data-toolbar="selected"]')
    this.selectedCountDisplay = this.toolbar.querySelector('[data-toolbar="selected-count"]')
    if (!skipClear) {
      this.clearSelected()
    }
  }

  handleChecked() {
    setTimeout(() => { this.toggleToolbar() }, 50)
  }

  selectAll(event: Event) {
    if (!(event?.target instanceof HTMLInputElement)) {
      return
    }

    const selected = event.target.checked;

    this.getCheckboxes().forEach(c => {
      c.checked = selected
    })

    this.toggleToolbar()
  }

  getCheckboxes(): HTMLInputElement[] | never[] {
    const checkboxes = (this.table?.querySelectorAll('tbody [type="checkbox"]'))
    if (!checkboxes) {
      return []
    }

    return Array.from(checkboxes)
      .filter(this.isInputElement)
      .map(e => e as HTMLInputElement)
  }

  selectedRows() {
    return Array.from(this.table?.tBodies[0].querySelectorAll("tbody tr:has(input:checked)"))
  }

  selectedIds() {
    return this.selectedRows()
      .flatMap(row => Array.from(row.querySelectorAll("input:checked")))
      .filter(this.isInputElement)
      .map(el => el.value)
  }

  getRowId(row: Element) {
    const idEl = row.querySelector("input:checked:first-child")
    if (idEl instanceof HTMLInputElement) {
      return idEl.value
    }
  }

  isInputElement(el: Element): el is HTMLInputElement {
    return el instanceof HTMLInputElement
  }

  toggleToolbar() {
    // Detect checkboxes state & count
    let checkedState = false;
    let count = 0;

    // Count checked boxes
    this.getCheckboxes().forEach(c => {
      if (c.checked) {
        checkedState = true;
        count++;
      }
    });

    // Toggle toolbars
    if (checkedState) {
      if (this.selectedCountDisplay) {
        this.selectedCountDisplay.innerHTML = count.toString();
      }
      if (this.toolbarUnchecked) {
        this.toolbarUnchecked.classList.add('d-none');
      }
      if (this.toolbarChecked) {
        this.toolbarChecked.classList.remove('d-none');
      }
    } else {
      if (this.toolbarUnchecked) {
        this.toolbarUnchecked.classList.remove('d-none');
      }
      if (this.toolbarChecked) {
        this.toolbarChecked.classList.add('d-none');
      }
    }
  }

  clearSelected() {
    this.clearHeaderCheckbox()
    this.getCheckboxes().forEach(c => {
      c.checked = false
    })

    this.toggleToolbar()
  }

  clearHeaderCheckbox() {
    const checkbox = this.table?.querySelector("thead input[type=checkbox]")
    if (checkbox instanceof HTMLInputElement) {
      checkbox.checked = false
    }
  }

  getAllCheckboxIds(): string[] {
    return this.getCheckboxes().map((c) => c.value)
  }

  restoreSelections(selectedIds: Set<string>) {
    this.clearHeaderCheckbox()
    this.getCheckboxes().forEach((c) => {
      c.checked = selectedIds.has(c.value)
    })
    this.toggleToolbar()
  }
}
